import { CSSProperties } from "react";

interface ImageProps {
  src: string;
  alt: string;
  style?: CSSProperties;
}

export const Image = ({ src, alt, style }: ImageProps) => (
  <img src={src} alt={alt} style={style} />
);
